import { __awaiter, __generator } from "tslib";
import { TransactionMode, } from '@tencent/memoire-core';
var IDBEngineCursor = /** @class */ (function () {
    function IDBEngineCursor(mode, proxyCursor, direction, engineAspects) {
        var _this = this;
        var _a;
        this.mode = mode;
        this.proxyCursor = proxyCursor;
        this.direction = direction;
        this.engineAspects = engineAspects;
        this.delete = undefined;
        this.update = undefined;
        if (mode !== TransactionMode.READ_ONLY) {
            this.delete = (function () {
                return _this.getProxyCursorWithMode().delete();
            });
            this.update = (function (value) {
                return _this.getProxyCursorWithMode().update(value);
            });
        }
        if ((_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.cursor) {
            this.applyAspectPatch();
        }
    }
    IDBEngineCursor.prototype[Symbol.asyncIterator] = function () {
        return new EngineCursorIterator(this);
    };
    IDBEngineCursor.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newCursor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.proxyCursor.continue()];
                    case 1:
                        newCursor = _a.sent();
                        if (!newCursor) {
                            return [2 /*return*/, null];
                        }
                        this.proxyCursor = newCursor;
                        return [2 /*return*/, this];
                }
            });
        });
    };
    IDBEngineCursor.prototype.value = function () {
        return this.proxyCursor.value;
    };
    IDBEngineCursor.prototype.getProxyCursorWithMode = function () {
        return this.proxyCursor;
    };
    /**
     * bind the hook stub to the cursor object
     */
    IDBEngineCursor.prototype.applyAspectPatch = function () {
        var _a;
        var cursorAspects = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.cursor;
        if (this.mode !== TransactionMode.READ_ONLY) {
            var readWriteCursor = this;
            cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.delete.patch(readWriteCursor, 'delete');
            cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.update.patch(readWriteCursor, 'update');
        }
        cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.next.patch(this, 'next');
        cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.value.patch(this, 'value');
    };
    return IDBEngineCursor;
}());
export { IDBEngineCursor };
var EngineCursorIterator = /** @class */ (function () {
    function EngineCursorIterator(engineCursor) {
        this.currentCursor = engineCursor;
    }
    EngineCursorIterator.prototype[Symbol.asyncIterator] = function () {
        return this;
    };
    EngineCursorIterator.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            var value, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.currentCursor) {
                            return [2 /*return*/, { value: undefined, done: true }];
                        }
                        value = this.currentCursor.value();
                        _a = this;
                        return [4 /*yield*/, this.currentCursor.next()];
                    case 1:
                        _a.currentCursor = _b.sent();
                        return [2 /*return*/, { value: value, done: false }];
                }
            });
        });
    };
    return EngineCursorIterator;
}());
//# sourceMappingURL=cursor.js.map